<div class="modal-dark">
  <div class="modal-header">
    <h4 class="modal-title">{{ categoryId ? 'Edit category name' : 'Add a category' }}:</h4>
  </div>
  <div class="modal-body">
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()"
        novalidate>
        <bo-non-field-errors></bo-non-field-errors>
        <app-form-field
          boFieldPath="name"
          label="Category name"
          [placeholder]="categoryId ? form.value : 'Enter category name'">
        </app-form-field>
        <div class="modal-footer px-0">
          <button
            type="button"
            class="btn btn-outline-dark me-2"
            (click)="onCancel()"
            aria-label="Cancel category action">
            Cancel
          </button>
          <app-submit
            [btnID]="'updateCategorySubmitBtn'"
            [disabled]="!form.valid"
            [busy]="busy"
            [icon]="false"
            label="{{ categoryId ? 'Update category' : 'Add category' }}">
          </app-submit>
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </div>
</div>
